import $console from "@zuto/utilities/src/$console"
import SubmissionService from "../services/submission-service"
import mapApplication, { Application, Metadata } from "../Mappers/ApplicationFormMapper"
import getConfig from "next/config"
import { EventsServiceResult } from "../services/events-service"
import { GetServerSidePropsContext } from "next"
import { ParsedUrlQuery } from "querystring"
import { AttributionDetails } from "../components/ApplicationForm/types"
import { ApplicationFormAnswers } from "../components/ApplicationForm/ApplicationFormContext"
import { mapFormlessApp } from "../Mappers/FormlessAppMapper/mapping"

const { publicRuntimeConfig } = getConfig()

export type FormlessAppMapProps = {
  prefillData: ApplicationFormAnswers,
  attribution: AttributionDetails,
  experimentName: string,
  metaData: Metadata,
  quoteId?: string,
  query: ParsedUrlQuery
}

export type SubmitFromlessApplicationProps = {
  application: Application,
  eventsService: EventsServiceResult,
  context?: GetServerSidePropsContext,
  isRetry?: boolean
}

export const mapFormlessApplication = ({
  prefillData,
  attribution,
  experimentName,
  metaData,
  quoteId,
  query
}: FormlessAppMapProps) => {
  const sanitisedPrefillData = mapFormlessApp(prefillData, attribution.source)
  const marketingPreferences = { email: false, sms: false, consentText: '' }
  return mapApplication(
    sanitisedPrefillData,
    attribution,
    experimentName,
    marketingPreferences,
    {
      ...metaData,
      isRetry: false
    },
    prefillData.vehicleDetails,
    quoteId,
    query
  ) as Application
}

export const getQueryParamValue = (
  param: string | string[] | undefined
): string | undefined => {
  if (typeof param === 'string') return param
  if (Array.isArray(param)) return param[0]
  return undefined
}

export const submitFromlessApplication = async ({
  application,
  eventsService,
  isRetry = false
}: SubmitFromlessApplicationProps) => {
  try {
    const response = await SubmissionService(publicRuntimeConfig).submitApplication(application)
    void eventsService.sendAppFormSubmittedEvent(true, isRetry)
      .catch(err => $console.error('sendAppFormSubmittedEvent failed', err))
    response.success = true
    return response
  } catch (err) {
    $console.error('Failed to submit application', err)
    void eventsService.sendAppFormSubmittedEvent(false, isRetry)
      .catch(err => $console.error('sendAppFormSubmittedEvent failed', err))
    return { success: false }
  }
}
